import React from "react";
import WatchList from "@components/V3/WatchList/index.js";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const MyWatchListPage = () => {

    return (
        <VersionedLayout>
            <WatchList />
        </VersionedLayout>
    );
};

export default MyWatchListPage;
